import "../static/footer.css";
import React from "react";
import applePlayIcon from "../static/images/app-store-badge.svg";
import gPlayIcon from "../static/images/google-play-badge.svg";
import facebookFooter from "../static/images/facebookFooter.png";
import instagramFooter from "../static/images/instagramFooter.png";
import linkedInFooter from "../static/images/LinkedinFooter.png";

import {
  APPLE_STORE_DOWNLOAD_LINK,
  GPLAY_DOWNLOAD_LINK,
} from "../../../utils/consts";
function Footer({ page }) {
  return (
    <footer className="text-lg-center text-md-center text-sm-start text-start text-xl-center text-muted footerDetailsContainer">
      <section className="d-flex justify-content-center justify-content-lg-between p-3 border-bottom footerSocialLinks">
        <a
          href="https://www.facebook.com/livewithombreindia"
          target="_blank"
          rel="noopener noreferrer"
          className="me-4 text-reset m-auto"
        >
          <div className="facebookIcon"></div>
        </a>
        <a
          href="https://www.instagram.com/livewithombre/"
          target="_blank"
          rel="noopener noreferrer"
          className="me-4 text-reset m-auto"
        >
          <div className="instaIcon"></div>
        </a>
        <a
          href="https://www.linkedin.com/company/live-ombr%C3%A9/"
          target="_blank"
          rel="noopener noreferrer"
          className="me-4 fa-xl-2x fa-lg-2x fa-md-2x fa-sm-lg fa-lg text-reset m-auto "
        >
          <div className="linkedInIcon"></div>
        </a>
      </section>
      <section className="">
        <div className="container-fluid mt-5">
          <div className="row mt-3 pt-5">
            <div className="col-md-3 col-lg-3 text-lg-start text-xl-start col-xl-3 w-100 mb-4 order-md-1 order-sm-3 order-3 p-0">
              <div className="contactUsDetails col-xl-7 col-lg-7 col-md-7 mx-auto p-0">
                <h6 className="footerDetailsHeading mb-xl-4 mb-lg-4 mb-md-4 mb-sm-2 mb-2 mt-sm-4 mt-4">
                  Contact Us
                </h6>
                <p>
                  <i className="fas fa-envelope contactIcons mr-2"></i>
                  <span className="contactEmail">livewithombre@gmail.com</span>
                </p>
                <p>
                  <i className="fas fa-phone contactIcons mr-2"></i>
                  <span className="contactNumber">+91-8287530547</span>
                </p>
              </div>
            </div>
            <div className="col-md-3 col-lg-3 col-xl-3 w-100 mb-4 order-md-2 order-sm-2 order-2 p-0">
              <h6 className="footerDetailsHeading mb-xl-4 mb-lg-4 mb-md-4 mb-sm-2 mb-2 mt-sm-4 mt-4">
                Social Media
              </h6>
              <div className="d-flex flex-row m-auto justify-content-xl-center justify-content-lg-center justify-content-md-center  p-0">
                <a
                  href="https://www.facebook.com/livewithombreindia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" text-reset col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 p-0 mr-xl-4 mr-lg-4 mr-md-4 mr-sm-0 "
                >
                  <img src={facebookFooter} alt="Facebook Footer" />
                </a>
                <a
                  href="https://www.instagram.com/livewithombre/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" text-reset col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 p-0  mr-xl-4 mr-lg-4 mr-md-4 mr-sm-0"
                >
                  <img src={instagramFooter} alt="Instagram Footer" />
                </a>
                <a
                  href="https://www.linkedin.com/company/live-ombr%C3%A9/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" text-reset col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 p-0"
                >
                  <img src={linkedInFooter} alt="linkedIn Footer" />
                </a>
              </div>
            </div>

            <div className="col-md-3 col-lg-3 col-xl-3 mx-xl-auto mb-4 order-md-3 order-sm-1 order-1 pl-xl-auto pl-lg-auto pl-md-auto  pl-sm-0 pl-0">
              <div className="downloadDetails col-xl-8 col-lg-8 col-md-8 mx-auto p-0">
                <h6 className="footerDetailsHeading mb-xl-4 mb-lg-4 mb-md-4 mb-sm-2 mb-2 mt-sm-4 mt-4">
                  Download The App
                </h6>
                <div className="row p-0 flex-xl-column flex-lg-column flex-md-column justify-content-xl-start align-items-xl-start justify-content-lg-start align-items-lg-start justify-content-md-start align-items-md-start ">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={APPLE_STORE_DOWNLOAD_LINK}
                    className="anchor"
                  >
                    <img
                      src={applePlayIcon}
                      className="appleDownload rounded mb-xl-2 mb-lg-2 mb-md-2 mr-xl-0 mr-lg-0 mr-md-0 mr-sm-2 mr-2"
                    ></img>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={GPLAY_DOWNLOAD_LINK}
                    className="anchor"
                  >
                    <img
                      src={gPlayIcon}
                      className="playstoreDownload rounded"
                    ></img>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg-3 col-xl-3 mx-xl-auto mb-4 order-md-4 order-sm-4 order-4 pl-xl-auto pl-lg-auto pl-md-auto  pl-sm-0 pl-0">
              <ul className="navbar-nav ml-auto" id="navbarItemsContainer">
                <li className="nav-item pr-xl-5 pr-lg-6 pr-md-5 py-2">
                  <a
                    className={
                      `nav-link titleHome ` +
                      (page !== "artist" && page !== "contact" ? "active" : "")
                    }
                    href="/#"
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item pr-xl-5 pr-lg-6 py-2 pr-md-5 pr-md-5">
                  <a
                    className={
                      `nav-link titleArtists ` +
                      (page === "artist" ? "active" : "")
                    }
                    href="/artist"
                  >
                    Artists
                  </a>
                </li>
                <li className="nav-item pr-xl-5 pr-lg-6 py-2 pr-md-5 pr-md-5">
                  <a
                    className={
                      `nav-link titleArtists ` +
                      (page === "contact" ? "active" : "")
                    }
                    href="/contact"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div className="text-reset text-lg-start text-xl-start ml-4 ml-sm-4 pb-5 pb-sm-5">
        © 2021 Copyright: All rights reserved
      </div>
    </footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/pages/Home/components/Footer.jsx